import React from 'react';
import { Box } from '@mui/material';
import { StatCard } from '@/components/ui';
import {
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  Receipt as ReceiptIcon,
  AccountBalance as BankIcon,
} from '@mui/icons-material';
import type {
  SuperadminTransactionMetrics,
  SuperadminTransactionSummaryCardsProps,
} from '../../types';

export const SuperadminTransactionSummaryCards: React.FC<
  SuperadminTransactionSummaryCardsProps
> = ({ stats, formatCurrency }) => {
  console.log('SuperadminTransactionSummaryCards - stats:', stats);
  const safeMetrics: SuperadminTransactionMetrics = {
    totalRevenue: stats?.total_amount ?? 0,
    failedAmount: stats?.failed_count ?? 0,
    pendingAmount: stats?.pendingAmount ?? 0,
    totalCount: stats?.total_transactions ?? 0,
    successRate: stats?.successRate ?? 0,
    failureRate: stats?.failureRate ?? 0,
    pendingRate: stats?.pendingRate ?? 0,
    totalRefunds: stats?.total_refunds ?? 0,
    totalRefundAmount: stats?.total_refund_amount ?? 0,
    todayTransactions: stats?.today_transactions ?? 0,
    todayAmount: stats?.today_amount ?? 0,
  };

  return (
    <Box display="grid" gridTemplateColumns="repeat(auto-fit, minmax(280px, 1fr))" gap={3} mb={4}>
      {/* Total Revenue */}
      <StatCard
        title="TOTAL REVENUE"
        subtitle="All successful transactions"
        value={formatCurrency(safeMetrics.totalRevenue)}
        // percentage={Math.round(safeMetrics.successRate)}
        // percentageLabel="Success Rate"
        trend="up"
        icon={<TrendingUpIcon />}
        color="success"
        size="medium"
      />

      {/* Failed Transactions */}
      <StatCard
        title="FAILED TRANSACTIONS"
        subtitle="Total failed transactions amount"
        value={formatCurrency(safeMetrics.failedAmount)}
        // percentage={Math.round(safeMetrics.failureRate)}
        // percentageLabel="Failure Rate"
        trend="down"
        icon={<TrendingDownIcon />}
        color="error"
        size="medium"
      />

      {/* Pending Transactions */}
      {/* <StatCard
        title="PENDING TRANSACTIONS"
        subtitle="Total pending amount"
        value={formatCurrency(safeMetrics.pendingAmount)}
        percentage={Math.round(safeMetrics.pendingRate)}
        percentageLabel="Pending Rate"
        trend="neutral"
        icon={<BankIcon />}
        color="warning"
        size="medium"
      /> */}

      {/* Total Transactions */}
      <StatCard
        title="TOTAL TRANSACTIONS"
        subtitle="All transactions across merchants"
        value={safeMetrics.totalCount.toString()}
        // percentage={Math.round(safeMetrics.successRate)}
        // percentageLabel="Success Rate"
        trend="up"
        icon={<ReceiptIcon />}
        color="primary"
        size="medium"
      />
      {/* Total Refunds */}
      <StatCard
        title="TOTAL REFUNDS"
        subtitle="Total number of refunds"
        value={safeMetrics.totalRefunds.toString()}
        // percentage={0}
        percentageLabel=""
        trend="down"
        icon={<ReceiptIcon />}
        color="error"
        size="medium"
      />

      {/* Refund Amount */}
      <StatCard
        title="REFUND AMOUNT"
        subtitle="Total refunded amount"
        value={formatCurrency(safeMetrics.totalRefundAmount)}
        // percentage={0}
        percentageLabel=""
        trend="down"
        icon={<TrendingDownIcon />}
        color="warning"
        size="medium"
      />

      {/* Today Transactions */}
      <StatCard
        title="TODAY'S TRANSACTIONS"
        subtitle="Transactions completed today"
        value={safeMetrics.todayTransactions.toString()}
        // percentage={0}
        percentageLabel=""
        trend="neutral"
        icon={<ReceiptIcon />}
        color="primary"
      />

      {/* Today Amount */}
      <StatCard
        title="TODAY'S AMOUNT"
        subtitle="Total amount processed today"
        value={formatCurrency(safeMetrics.todayAmount)}
        // percentage={0}
        percentageLabel=""
        trend="up"
        icon={<TrendingUpIcon />}
        color="success"
      />
    </Box>
  );
};

export default SuperadminTransactionSummaryCards;
